import { WrappedFieldProps } from 'redux-form';

import ConnectedTagSelect from 'dashboard/components/ConnectedTagSelect';
import FormControlLabel from 'dashboard/components/FormControls/FormControlLabel';
import FormError from 'dashboard/components/FormControls/FormError';
import FormGroup from 'dashboard/layouts/FormLayout/FormGroup';
import { TagScope } from 'dashboard/models/tag';
import FormControlProps from 'lib/interfaces/FormControlProps';

export interface ConnectedTagSelectFieldProps extends FormControlProps, WrappedFieldProps {
  id?: string;
  className?: string;
  placeholder?: string;
  disabled?: boolean;
  label?: string;
  tagScope: TagScope;
}

const ConnectedTagSelectField = ({
  id,
  className,
  placeholder,
  disabled,
  label,
  input,
  tagScope,
  meta: { error, submitFailed, touched },
}: ConnectedTagSelectFieldProps) => {
  const hasError = !!(error && (submitFailed || touched));

  const onChange = (newValue: string[]) => {
    input.onChange(newValue);
  };

  const value = Array.isArray(input.value) ? input.value : input.value ? [input.value] : [];

  return (
    <FormGroup className={className}>
      {label && <FormControlLabel htmlFor={id}>{label}</FormControlLabel>}
      <ConnectedTagSelect
        id={id}
        name={input.name}
        value={value}
        placeholder={placeholder}
        hasError={hasError}
        disabled={disabled}
        onChange={onChange}
        tagScope={tagScope}
      />
      {hasError && <FormError>{error}</FormError>}
    </FormGroup>
  );
};

export default ConnectedTagSelectField;
